module.exports = __webpack_public_path__ + "img/scan-screen.b69c7f0b.jpg";